export default __webpack_public_path__ + "static/operator-348f9a3e789948e226225d9502426938.png";